var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#7D35BC",
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.548 12.102a.259.259 0 0 0 .259.258h4.39a.909.909 0 0 0 .904-.904v-1.033a.904.904 0 0 0-.904-.904h-4.39a.258.258 0 0 0-.259.258v2.325ZM7.77 12.36h3.745a.258.258 0 0 0 .258-.258V9.777a.258.258 0 0 0-.258-.258H6.866a.904.904 0 0 0-.904.904v1.033a.91.91 0 0 0 .904.904h.904ZM11.774 13.393a.258.258 0 0 0-.259-.258H7.254a.258.258 0 0 0-.258.258v4.003a.91.91 0 0 0 .904.904h3.615a.258.258 0 0 0 .259-.258v-4.649ZM12.807 13.135a.258.258 0 0 0-.259.258v4.649a.258.258 0 0 0 .259.258h3.357a.91.91 0 0 0 .904-.904v-4.003a.258.258 0 0 0-.258-.258h-4.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.548 9.37a.517.517 0 0 0 .517.149c.61-.15 2.066-.517 2.526-.992a1.55 1.55 0 0 0-2.165-2.18c-.387.393-.764 1.591-.991 2.531a.517.517 0 0 0 .113.491Zm1.591-2.29a.516.516 0 1 1 .698.698 4.542 4.542 0 0 1-1.178.48c.11-.414.258-.81.48-1.177ZM11.887 8.879c-.227-.94-.604-2.139-.992-2.532a1.55 1.55 0 1 0-2.159 2.165c.444.45 1.917.842 2.526.992a.516.516 0 0 0 .517-.135.516.516 0 0 0 .108-.49Zm-2.438-1.1a.517.517 0 0 1 .713-.698c.253.149.376.764.48 1.178-.418-.103-1.116-.344-1.193-.48Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h14v14H5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.1bc14f2bb9617593d8b962e8ed9140bf.svg";
export { ForwardRef as ReactComponent };